module.exports = __webpack_public_path__ + "static/img/cymsh5.7ee2274.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cymsh5.png
// module id = nLth
// module chunks = 1